import React from 'react';
import DisplayField from '../../../../../itrust_common/components/others/DisplayField'
import OldValuesHeader from '../../oldValues/OldValuesHeader';

let VisualAcuity = props => {
  const { template, previousExams, fieldKey, overviewName, examId, fieldsValues } = props;

  const renderTable = (fieldsValues) => (
    <div className="col-12">
      <div className="overview-table mb-3">
        <table className="table table-bordered bg-light table-hover shadow-none border border-muted">
          <thead className="text-dark border border-muted">
            <tr className="text-center">
              <th scope="col"></th>
              <th scope="col"><DisplayField isVisible={true} label={'Distance'} /></th>
              <th scope="col"><DisplayField isVisible={true} label={'Near'} /></th>
            </tr>
          </thead>
          <tbody>
            {["od", "os", "ou"].map(type =>
              <tr className="text-center">
                <td><h6>{type.toUpperCase()}</h6></td>
                <td>
                  <DisplayField
                    isVisible={template.fields[`distance_${type}`]['visible']}
                    value={fieldsValues?.[`${type}_distance`]}
                  />
                </td>
                <td>
                  <DisplayField
                    isVisible={template.fields[`near_${type}`]['visible']}
                    value={fieldsValues?.[`${type}_near`]}
                  />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      { fieldsValues?.notes && <DisplayField
        isVisible={template.fields.notes.visible}
        label={`${template.fields.notes.custom_label}:`}
        value={fieldsValues.notes}
        className=""
      /> }
    </div>
  )

  return (
    <>
      {fieldsValues && renderTable(fieldsValues)}
      {previousExams?.filter(item => item.id !== examId).map(prevExam =>
        <div className="col-12 border rounded mb-4 px-0">
          <div className="row mx-0">
            <OldValuesHeader prevExam={prevExam} overviewName={overviewName} examId={examId} />
            {renderTable(prevExam?.[fieldKey])}
          </div>
        </div>
      )}
    </>
  )
}


export default VisualAcuity;